import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const AutoAwesomeOutlined = forwardRef<SVGSVGElement, SvgIconProps>(
  (props, ref) => (
    <SvgIcon {...props} ref={ref} viewBox="0 0 16 16">
      <path d="M12.6667 5.99984L13.5 4.1665L15.3333 3.33317L13.5 2.49984L12.6667 0.666504L11.8333 2.49984L10 3.33317L11.8333 4.1665L12.6667 5.99984Z" />
      <path d="M12.6667 10L11.8333 11.8333L10 12.6667L11.8333 13.5L12.6667 15.3333L13.5 13.5L15.3333 12.6667L13.5 11.8333L12.6667 10Z" />
      <path d="M7.66669 6.33317L6.00002 2.6665L4.33335 6.33317L0.666687 7.99984L4.33335 9.6665L6.00002 13.3332L7.66669 9.6665L11.3334 7.99984L7.66669 6.33317ZM6.66002 8.65984L6.00002 10.1132L5.34002 8.65984L3.88669 7.99984L5.34002 7.33984L6.00002 5.8865L6.66002 7.33984L8.11335 7.99984L6.66002 8.65984Z" />
    </SvgIcon>
  )
);

AutoAwesomeOutlined.displayName = 'AutoAwesomeOutlined';

export default AutoAwesomeOutlined;
